import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import { storeMixin } from '@/store/$u.mixin.js';
import Antd from 'ant-design-vue';
import '@/less/_style.less';


const app = createApp(App);

app.config.globalProperties.$u = {};
app.use(store).mixin(storeMixin);
app.use(Antd).use(router);

app.mount('#app');
